import { Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Abonnement } from 'src/app/models/abonnement.model';
import { ApiService } from 'src/app/services/api.service';

interface EffectiveEntitlement {
	active: boolean;
	classes: number;
	expirationDate: string | null;
	source: string | null;
}

@Injectable()
export class AbonnementsService {
	public abonnement = signal<Abonnement | null>(null);

	constructor(private api: ApiService) {}

	async getUserSubscription(): Promise<void> {
		const data = await firstValueFrom(
			this.api.get<EffectiveEntitlement | null>('/subscriptions'),
		);
		if (!data) {
			this.abonnement.set(null);
			return;
		}
		this.abonnement.set({
			paidClasses: data.classes,
			expirationDate: data.expirationDate ?? '',
			userId: '',
			isActive: data.active,
		});
	}
}
